import React from "react";
import { Box } from "@mui/material";

const BaseBox = ({ children, sx = {}, ...props }) => {
  return (
    <Box
      sx={{
        width: "100%",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default BaseBox;
